var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import Notice from "./Notice";
export default function useNotification(notificationInstance) {
    var createdRef = React.useRef({});
    var _a = React.useState([]), elements = _a[0], setElements = _a[1];
    function notify(noticeProps) {
        var firstMount = true;
        notificationInstance.add(noticeProps, function (div, props) {
            var key = props.key;
            if (div && (!createdRef.current[key] || firstMount)) {
                var noticeEle_1 = _jsx(Notice, __assign({}, props, { holder: div }));
                createdRef.current[key] = noticeEle_1;
                setElements(function (originElements) {
                    var index = originElements.findIndex(function (ele) { return ele.key === props.key; });
                    if (index === -1) {
                        return __spreadArray(__spreadArray([], originElements, true), [noticeEle_1], false);
                    }
                    var cloneList = __spreadArray([], originElements, true);
                    cloneList[index] = noticeEle_1;
                    return cloneList;
                });
            }
            firstMount = false;
        });
    }
    return [notify, _jsx(_Fragment, { children: elements })];
}
